import { Success, useEnsureValue } from "@indietabletop/appkit";
import { useCallback } from "react";
import { href } from "../App/href";
import { client } from "../client";
import { database } from "../database/database";
import type { Warband } from "../engine/Warband";

export function useEnsureShareId(warband: Warband) {
  const createGangSnapshot = useCallback(async () => {
    const snapshot = await client.createSnapshot("greathelm", warband.data);

    if (!snapshot.isSuccess) {
      return snapshot.mapFailure((failure) => {
        if (failure.type === "NETWORK_ERROR") {
          return `Failed to share due to a network issue.`;
        }

        return `Failed to share. Please restart the app.`;
      });
    }

    // Save and return new snapshot value
    const { snapshotId } = snapshot.value;

    await database.warbands.updateOne(
      { ...warband.data, snapshotId },
      { allowSetSnapshotId: true },
    );

    return new Success(snapshotId);
  }, [warband]);

  return useEnsureValue(warband.data.snapshotId, createGangSnapshot);
}

export function getShareLink(snapshotId: string) {
  return href("~/shared/w/:warbandId", {
    path: { warbandId: snapshotId },
    withOrigin: true,
  });
}
